<div class="mini-grid">
    <p class="no-margin prevent-selection">{{ text }}</p>
    <img [src]="icon" [alt]="text" class="img" />
</div>